<template>
	<div style="margin-top: 0px;">

		<!-- 3.使用组件 -->
		<!-- 页头 -->
		<roheader></roheader>
		<!-- 内容 -->
		<!-- <el-button @click="showDialog">打开弹出框</el-button> -->
		<!--    <el-dialog
		         title="提示"
		         :visible.sync="dialogVisible"
		         width="50%"
		         :before-close="handleClose"
		       >
		         <slot>创建成功</slot>
		       </el-dialog> -->

		<div style="width:100%;background: #F1F1F1;overflow: auto;padding-bottom: 30px;">
			<div style="width:1200px;margin:auto;padding:20px;">
				<rosidebar></rosidebar>
				<div style="float: right;width:calc(100% - 269px);overflow: auto;height:1090px;background: white;">
					<h6 style="border-bottom: 1px solid #F1F1F1;line-height: 70px;text-align: left;padding-left: 20px;">
						<!-- 您的位置： -->
						<!-- <span style="color:gray;">首页</span> > <span style="color:gray;">个人中心</span> > -->
						<span style="color:#07ccec;">新增发票信息</span>
					</h6>
					<el-form label-width="150px" class="demo-ruleForm" style="padding:20px;" :model="form" ref="form"
						:rules="form_rules">
						<el-form-item label="发票抬头" style="margin-top: 30px;" prop="unit_name">
							<el-input v-model="form.unit_name" placeholder="必填"></el-input>
						</el-form-item>
						<div style="overflow: hidden;">
							<el-form-item label="默认发票类型" style="float: left;width: 100%;">
								<el-radio style="float: left;margin-top: 8px;">增值税普通发票</el-radio>
							</el-form-item>

						</div>
						<div style="overflow: hidden;">
							<el-form-item label="统一社会信用用代码" style="float: left;width: 100%;" prop="tax_number">
								<el-input v-model="form.tax_number" placeholder="必填"></el-input>
								<div>请与贵单位财务人员核实后，仔细填写准确的三证合一后的社会统一信用代码，否则将影响后续发票的正常使用。</div>
							</el-form-item>

						</div>
						<div style="overflow: hidden;">

							<el-form-item label="开户银行名称" prop="bank">
								<el-input v-model="form.bank" placeholder="选填"></el-input>
							</el-form-item>
							<el-form-item label="基本开户账号" prop="account">
								<el-input v-model="form.account" placeholder="选填"></el-input>
							</el-form-item>
							<el-form-item label="注册场所地址" prop="address">
								<el-input v-model="form.address" placeholder="选填"></el-input>
							</el-form-item>

							<el-form-item label="注册固定电话" prop="phone">
								<el-input v-model="form.phone" placeholder="选填"></el-input>
							</el-form-item>

						</div>

					</el-form>

					<el-checkbox v-model="checked">设为默认</el-checkbox>
					<div style="overflow: hidden;width: 50%;margin:15px auto;">
						<a @click="create_invoice_data" style="font-size: 12px;">
							<button class="vs-btn style2"
								style="border-radius: 10px;height:35px;width: 150px;background-color: red;color:white;padding:0;border-radius: 5px;">确认</button>
						</a>
					</div>
				</div>

			</div>
		</div>
		<!-- 页脚 -->
		<rofooter></rofooter>
	</div>

</template>



<script>
	import {
		fetchGet,
		fetchPost
	} from "../utils/request"
	import qs from 'qs'
	// 1.导入组件
	import roheader from "./components/ro_header.vue";
	import rofooter from "./components/ro_footer.vue";
	import rosidebar from "./components/ro_sidebar.vue";
	export default {
		name: 'Demo',
		data() {
			return {
				form: {
					'unit_name': '',
					'address': '',
					'bank': '',
					'tax_number': '',
					'phone': '',
					'account': '',

				},
				form_rules: {
					unit_name: [{
						required: true,
						message: '请输入发票抬头',
						trigger: 'blur'
					}],
					// address: [{ required: true, message: '请输入注册场所地址', trigger: 'blur' }],
					// bank: [{ required: true, message: '请输入开户行名称', trigger: 'blur' }],
					tax_number: [{
						required: true,
						message: '请输入统一社会信用码',
						trigger: 'blur'
					}],
					// phone: [{ required: true, message: '请输入注册固定电话', trigger: 'blur' }],
					// account: [{ required: true, message: '请输入开户账号', trigger: 'blur' }],
				},

			}
		},
		mounted() {
			//第一个对比供应商信息加载
		},
		components: {
			// 2.注册局部组件
			roheader,
			rofooter,
			rosidebar,
		},
		methods: {
			handleClose(done) {
				var self = this
				var order_ids = this.$route.query.order_ids
				var total_fees = this.$route.query.total_fees
				// debugger
				if(order_ids!=undefined){
					this.$confirm('确认创建？')
						.then(_ => {
							self.$router.push('/user/invoice?order_ids='+order_ids+'&total_fees='+total_fees)
						})
						.catch(_ => {});
				}else{
					this.$confirm('确认创建？')
						.then(_ => {
							self.$router.back()
						})
						.catch(_ => {});
				}
			
			},

			create_invoice_data() {

				var data = {
					'id': window.localStorage.getItem('eshop_user_id'),
					'unit_name': this.form.unit_name,
					'tax_number': this.form.tax_number,
					'address': this.form.address,
					'bank': this.form.bank,
					'phone': this.form.phone,
					'account': this.form.account,
					'default': this.checked,

				}
				console.log(data)
				var self = this
				this.$refs.form.validate(valid => {
					if (valid) {
						// 表单验证通过，提交表单
						self.handleClose()
						fetchPost('/ro/eshop/invoice/create/v1', data).then(response => {


						})
					}
				});
			}
		}
	}
</script>
<style>
	@import url("../static/css/css2.css");
	@import url("../static/css/app.min.css");
	@import url("../static/css/fontawesome.min.css");
	@import url("../static/css/animate.min.css");
	@import url("../static/css/style.css");

	#app {
		margin-top: 0px !important;
	}

	.ro-register-input-box {
		width: 60%;
		overflow: hidden;
		line-height: 50px;
		margin: auto;
	}

	.ro-register-input-box span {
		font-weight: 800;
	}

	.ro-register-input {
		border-radius: 10px !important;
		height: 50px !important;
		margin-bottom: 15px;
		width: 80%;
		float: left;
	}

	.vs-btn.style3,
	.vs-btn.style2 {
		margin-left: 0;
	}

	.el-form-item__label {
		font-weight: 500;
		color: #333333 !important;
	}
</style>